import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "project-component flex gap flex-responsive" }
const _hoisted_2 = { class: "image-container flex-1 flex-vh-center text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content-container flex-2" }
const _hoisted_5 = { class: "flex gap-small" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("More Details")
const _hoisted_8 = {
  key: 0,
  class: "flex-auto"
}
const _hoisted_9 = {
  key: 1,
  class: "flex-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FolderIcon = _resolveComponent("FolderIcon")!
  const _component_ProjectTagComponent = _resolveComponent("ProjectTagComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ExternalLinkIcon = _resolveComponent("ExternalLinkIcon")!
  const _component_LinkComponent = _resolveComponent("LinkComponent")!
  const _component_GitHubIcon = _resolveComponent("GitHubIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.project.previewImageUrl === null)
        ? (_openBlock(), _createBlock(_component_FolderIcon, {
            key: 0,
            width: 48,
            height: 48
          }))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _ctx.project.previewImageUrl
          }, null, 8, _hoisted_3))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.project.title), 1),
      _createElementVNode("small", null, _toDisplayString(_ctx.displayDate), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.project.summary), 1),
      _createElementVNode("p", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.tags, (tag, index) => {
          return (_openBlock(), _createBlock(_component_ProjectTagComponent, {
            key: `${_ctx.project.reference}-tag-${index}`,
            tag: tag
          }, null, 8, ["tag"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: _ctx.url }, {
            default: _withCtx(() => [
              _createVNode(_component_ButtonComponent, null, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        (_ctx.project.viewUrl !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_LinkComponent, {
                href: _ctx.project.viewUrl
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ButtonComponent, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ExternalLinkIcon)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.project.sourceCodeUrl !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_LinkComponent, {
                href: _ctx.project.sourceCodeUrl
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ButtonComponent, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_GitHubIcon)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}